var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control az_base_inp",domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', +$event.target.value)}}},_vm._l((_vm.range),function(item){return _c('option',{domProps:{"value":item}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }